import { makeStyles } from '@material-ui/core'
import React from 'react'
import { Container } from './Container'
import heroImg from '../../assets/mechanicaldesign/newbanner.png'

const useStyles = makeStyles(() => ({
    hero: {
        position: 'relative',
        minHeight: 600,
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        '@media (max-width: 640px)': { minHeight: 460 },
    },
    media: {
        position: 'absolute',
        inset: 0,
        '& img': { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },
    },
    overlay: {
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(90deg, rgba(20,20,40,0.72) 0%, rgba(20,20,40,0.45) 55%, rgba(20,20,40,0.25) 100%)',
    },
    content: {
        position: 'relative',
        zIndex: 2,
        color: '#fff',
        padding: '90px 24px',
        maxWidth: 780,
        '@media (max-width: 640px)': { padding: '60px 20px' },
    },
    h1: {
        color: '#fff',
        fontSize: 'clamp(1.8rem, 4vw, 3rem)',
        fontWeight: 600,
        letterSpacing: '.3px',
        marginBottom: 16,
    },
    subtitle: {
        fontSize: 'clamp(1rem, 1.6vw, 1.25rem)',
        color: '#EDEDF7',
        fontWeight: 400,
        letterSpacing: '.3px',
    },
}))

export function Hero() {
    const classes = useStyles()
    return (
        <section className={classes.hero} id="top">
            <div className={classes.media}>
                <img src={heroImg} alt="Engineer working on mechanical design test fixture" />
            </div>
            <div className={classes.overlay} />
            <Container className={classes.content}>
                <h1 className={classes.h1}>
                    One Stop Solution For All Test Automation
                </h1>
                <p className={classes.subtitle}>
                    Design, Engineering &amp; Test Fixture Automation
                </p>
            </Container>
        </section>
    )
}
